
const paginationafterfilter = () => {

  const loadMoreButton = document.getElementById('load-more-button');
if(loadMoreButton){
  const pagination = document.getElementById('pagination');
if (pagination) {
  loadMoreButton.addEventListener('click', function() {
    const nextPageLink = pagination.querySelector('.next a');
       if (!nextPageLink || fetchedURLs.has(nextPageLink.getAttribute('href'))) {
      loadMoreButton.style.display = 'none';
      return;
    }
    loadMoreButton.classList.add('loading');
    fetch(nextPageLink.getAttribute('href'))
      .then(response => response.text())
      .then(html => {
        
        const parser = new DOMParser();
        const htmlDoc = parser.parseFromString(html, 'text/html');
        const productsContainer = htmlDoc.querySelector('#AjaxinateContainer');
        const newProducts = productsContainer.innerHTML;
        document.querySelector('#AjaxinateContainer').innerHTML += newProducts;
        let mypagination = htmlDoc.querySelector('#pagination');
         let nextpage = mypagination.querySelector('.next a');
        if(nextpage){
          let nextpageurl = mypagination.querySelector('.next a').getAttribute("href");
          pagination.querySelector('.next a').setAttribute('href', nextpageurl);
        }else{
          loadMoreButton.style.display = "none";
        }        
        initButtons();
        loadMoreButton.classList.remove('loading');
       
      })
      .catch(error => {
        console.error(error);
        loadMoreButton.classList.remove('loading');
      });
  });
}
}else {
  let fetchedURLs = new Set();

    // Get the pagination element
    const pagination = document.getElementById('pagination');
    if(pagination){   
     
    // Create the IntersectionObserver instance
    const observer = new IntersectionObserver(entries => {
      // Check if the pagination element has entered the viewport
      if (entries[0].isIntersecting) {
      
        const nextPageLink = pagination.querySelector('.next a');

        // Check if the next page link exists and not fetched
        if (!nextPageLink || fetchedURLs.has(nextPageLink.getAttribute('href'))) {
          const collectionLoader = document.getElementById('collectionloader');
collectionLoader?collectionLoader.style.display = 'none' : null;

          return;
        }
        
      const container = document.querySelector('#AjaxinateContainer');
        // Load the next page of products
        fetch(nextPageLink.getAttribute('href'))
          .then(response => response.text())
          .then(html => {
            // Add the fetched URL to the set
            fetchedURLs.add(nextPageLink.getAttribute('href'));

            // Parse the HTML string into a DOM element
            const parser = new DOMParser();
            const htmlDoc = parser.parseFromString(html, 'text/html');

            // Extract the new products from the HTML
            const productsContainer = htmlDoc.querySelector('#AjaxinateContainer');
            const newProducts = productsContainer.innerHTML;            
           const container = document.querySelector('#AjaxinateContainer');
 
            // Append the new products to the existing products
            document.querySelector('#AjaxinateContainer').innerHTML += newProducts;

            // Update the next page link
            let mypagination = htmlDoc.querySelector('#pagination');
            let nextpage = mypagination.querySelector('.next a')
            if(nextpage){
            let nextpageurl = mypagination.querySelector('.next a').getAttribute("href");
              pagination.querySelector('.next a').setAttribute('href', nextpageurl);
            }
             initButtons();
            
          
          });
      }
    });

    // Start observing the pagination element
    observer.observe(pagination);
     }
}

}
document.addEventListener('change', (e) => {
  if (e.target.matches('#sort-by input')) {
    console.log()
    
    const searchParams = new URLSearchParams(window.location.search);
    searchParams.set(e.target.getAttribute('name'), e.target.value);  
    window.location.search = searchParams.toString();
  }
});


// Collection - infinite scrolling (Ajaxinate)
const initAjaxinate = () => {
    if (document.querySelector('#AjaxinatePagination')) {
        (() => new Ajaxinate({
            pagination: '#AjaxinatePagination',
            container: '#AjaxinateContainer',
            method: 'click',
            loadingText: 'Loading...',
            callback: () => {
                window.restartProductListItemsAnimation();
            },
        }))();
    }
};
initAjaxinate();

// Collection - fix sticky position for filters sidebar
const fixCollectionSidebarStickyPos = () => {
    const el = document.querySelector('#filters-sticky-top');
    if (el) {
        const navbarHeight = document.querySelector('#shopify-section-navbar.sticky-top')?.clientHeight || 0;
        el.style.top = `${navbarHeight + 20}px`;
        el.style.zIndex = '1019';
        el.style.maxHeight = `calc(100vh - ${navbarHeight + 40}px)`;
        el.style.overflow = 'auto';
    }
};
fixCollectionSidebarStickyPos();

// Handle Collection filters
const handleCollectionFilters = () => {
    const form = document.querySelector('#filter-form');

    if (!form) {
        return;
    }

    document.querySelectorAll('.collection-filter').forEach((filter) => {
      let lastClickedElement;
        filter.addEventListener('change', (e) => {
            const searchParams = new URLSearchParams(window.location.search);
            const productList = document.querySelector('#main .product-list');

            if (productList) {
                productList.style.opacity = 0.25;
            }

            if (e.target.getAttribute('type') === 'checkbox') {
                if (e.target.checked) {
                    searchParams.append(e.target.getAttribute('name'), e.target.getAttribute('value'));
                } else {
                    const array = [];
                    searchParams.forEach((value, key) => {
                        if (value !== e.target.getAttribute('value')) {
                            array.push({ [key]: value });
                        }
                    });
                    searchParams.delete(e.target.getAttribute('name'));
                    array.forEach((item) => {
                        const key = Object.keys(item)[0];
                        const value = Object.values(item)[0];
                        searchParams.append(key, value);
                    });
                }
            }
            if (e.target.getAttribute('type') === 'number') {
                if (e.target.value > 0) {
                    searchParams.set(e.target.getAttribute('name'), e.target.value);
                } else {
                    searchParams.delete(e.target.getAttribute('name'));
                }
            }
            const url = `${window.location.pathname}?${searchParams}`;
            window.history.replaceState({}, '', url);
             lastClickedElement = e.target;
            setTimeout(() => {
                const offcanvas = document.querySelector('#offcanvas-filters');
                bootstrap.Offcanvas.getInstance(offcanvas)?.hide();
            }, 200);

            fetch(window.location.href)
                .then((response) => response.text())
                .then((data) => {
                    const parser = new DOMParser();
                    const newDocument = parser.parseFromString(data, 'text/html');
                    let pricgroup = newDocument.querySelector('#filters-col') || newDocument.querySelector(' #filters-col-top')
                    let getValueMin = pricgroup.querySelector('.filterpricemin');
                    let getValueMax = pricgroup.querySelector('.filterpricemax');
                    if (getValueMin.value || getValueMax.value) {
                    const closestFilterCollapse = getValueMin.closest('.filter-collapse') || getValueMax.closest('.filter-collapse');  
                    if (closestFilterCollapse) {
                    closestFilterCollapse.classList.remove('filter-collapse');
                    closestFilterCollapse.classList.add('show');
                    }
                    }
                    
                   

                    document.querySelector('#filters-col ,#filters-col-top').replaceWith(newDocument.querySelector('#filters-col,#filters-col-top'));
                    document.querySelector('#main-col').replaceWith(newDocument.querySelector('#main-col'));
                    handleCollectionFilters();
                    initAjaxinate();
                    fixCollectionSidebarStickyPos();
                    initButtons();
                    paginationafterfilter();
                    //window.restartProductListItemsAnimation();
                   if (lastClickedElement && (lastClickedElement.classList.contains('filterpricemin') || lastClickedElement.classList.contains('filterpricemax'))) {                    
                     if (lastClickedElement.classList.contains('filterpricemin')) {
                    console.log('Last clicked element contains class "filterpricemin"');
                       let focusElement = document.querySelector('.filterpricemax');
                       console.log(focusElement)
                       if (focusElement) {
                    focusElement.focus();}
                       }  
                    if (lastClickedElement.classList.contains('filterpricemax')) {
                       let focusElement = document.querySelector('.filterpricemin');
                      console.log(focusElement)
                       if (focusElement) {
                    focusElement.focus();              
                      }
                    }
                    }
                });
        });
    });

    document.querySelectorAll('.active-filter').forEach((el) => {
        el.addEventListener('click', (e) => {
            e.preventDefault();

            const productList = document.querySelector('#main .product-list');

            if (productList) {
                productList.style.opacity = 0.25;
            }

            window.history.replaceState({}, '', e.target.getAttribute('href'));

            fetch(window.location.href)
                .then((response) => response.text())
                .then((data) => {
                    const parser = new DOMParser();
                    const newDocument = parser.parseFromString(data, 'text/html');
                    document.querySelector('#filters-col ,#filters-col-top').replaceWith(newDocument.querySelector('#filters-col ,#filters-col-top'));
                    document.querySelector('#main-col').replaceWith(newDocument.querySelector('#main-col'));
                    handleCollectionFilters();
                    initAjaxinate();
                    fixCollectionSidebarStickyPos();
                  initButtons();
                  paginationafterfilter();
                });
        });
    });
};
handleCollectionFilters();
//mobile collection filter 
const sidebarhandleCollectionFilters = () => {
    const form = document.querySelector('#sidebar-filter-form');

    if (!form) {
        return;
    }

    document.querySelectorAll('.side-bar-collection-filter').forEach((filter) => {
     
        filter.addEventListener('change', (e) => {
   
            const searchParams = new URLSearchParams(window.location.search);
            const productList = document.querySelector('#main .product-list');

            if (productList) {
                productList.style.opacity = 0.25;
            }

            if (e.target.getAttribute('type') === 'checkbox') {
                if (e.target.checked) {
                    searchParams.append(e.target.getAttribute('name'), e.target.getAttribute('value'));
                } else {
                    const array = [];
                    searchParams.forEach((value, key) => {
                        if (value !== e.target.getAttribute('value')) {
                            array.push({ [key]: value });
                        }
                    });
                    searchParams.delete(e.target.getAttribute('name'));
                    array.forEach((item) => {
                        const key = Object.keys(item)[0];
                        const value = Object.values(item)[0];
                        searchParams.append(key, value);
                    });
                }
            }
            if (e.target.getAttribute('type') === 'number') {
                if (e.target.value > 0) {
                    searchParams.set(e.target.getAttribute('name'), e.target.value);
                } else {
                    searchParams.delete(e.target.getAttribute('name'));
                }
            }
            const url = `${window.location.pathname}?${searchParams}`;
            window.history.replaceState({}, '', url);

            setTimeout(() => {
                const offcanvas = document.querySelector('#offcanvas-filters');
                bootstrap.Offcanvas.getInstance(offcanvas)?.hide();
            }, 200);

            fetch(window.location.href)
                .then((response) => response.text())
                .then((data) => {
                    const parser = new DOMParser();
                    const newDocument = parser.parseFromString(data, 'text/html');
                  console.log(document.querySelector('#mob-filters-col'));
                    document.querySelector('#mob-filters-col').replaceWith(newDocument.querySelector('#mob-filters-col'));
                    document.querySelector('#main-col').replaceWith(newDocument.querySelector('#main-col'));
                    sidebarhandleCollectionFilters();
                    initAjaxinate();
                  initButtons();
                    fixCollectionSidebarStickyPos();
                  paginationafterfilter();
                    //window.restartProductListItemsAnimation();
                });
        });
    });

    document.querySelectorAll('.active-filter').forEach((el) => {
        el.addEventListener('click', (e) => {
            e.preventDefault();

            const productList = document.querySelector('#main .product-list');

            if (productList) {
                productList.style.opacity = 0.25;
            }

            window.history.replaceState({}, '', e.target.getAttribute('href'));

            fetch(window.location.href)
                .then((response) => response.text())
                .then((data) => {
                    const parser = new DOMParser();
                    const newDocument = parser.parseFromString(data, 'text/html');
                    document.querySelector('#mob-filters-col').replaceWith(newDocument.querySelector('#mob-filters-col'));
                    document.querySelector('#main-col').replaceWith(newDocument.querySelector('#main-col'));
                    sidebarhandleCollectionFilters();
                    initAjaxinate();
                  initButtons();
                    fixCollectionSidebarStickyPos();
                  paginationafterfilter();
                });
        });
    });
};
sidebarhandleCollectionFilters();

//mobile collection filter 
const topbarCollectionFilters = () => {
    const form = document.querySelector('#top-filter-form');

    if (!form) {
        return;
    }

    document.querySelectorAll('.top-filter').forEach((filter) => {
     
        filter.addEventListener('change', (e) => {
   
            const searchParams = new URLSearchParams(window.location.search);
            const productList = document.querySelector('#main .product-list');

            if (productList) {
                productList.style.opacity = 0.25;
            }

            if (e.target.getAttribute('type') === 'checkbox') {
                if (e.target.checked) {
                    searchParams.append(e.target.getAttribute('name'), e.target.getAttribute('value'));
                } else {
                    const array = [];
                    searchParams.forEach((value, key) => {
                        if (value !== e.target.getAttribute('value')) {
                            array.push({ [key]: value });
                        }
                    });
                    searchParams.delete(e.target.getAttribute('name'));
                    array.forEach((item) => {
                        const key = Object.keys(item)[0];
                        const value = Object.values(item)[0];
                        searchParams.append(key, value);
                    });
                }
            }
            if (e.target.getAttribute('type') === 'number') {
                if (e.target.value > 0) {
                    searchParams.set(e.target.getAttribute('name'), e.target.value);
                } else {
                    searchParams.delete(e.target.getAttribute('name'));
                }
            }
          
            const url = `${window.location.pathname}?${searchParams}`;
            window.history.replaceState({}, '', url);

            setTimeout(() => {
                const offcanvas = document.querySelector('#offcanvas-filters');
                bootstrap.Offcanvas.getInstance(offcanvas)?.hide();
            }, 200);

            fetch(window.location.href)
                .then((response) => response.text())
                .then((data) => {
                    const parser = new DOMParser();
                    const newDocument = parser.parseFromString(data, 'text/html');                  
                    
                    document.querySelector('#main-col').replaceWith(newDocument.querySelector('#main-col'));
                    topbarCollectionFilters();
                    initAjaxinate();
                    initButtons();
                    fixCollectionSidebarStickyPos();
                  paginationafterfilter();
                    //window.restartProductListItemsAnimation();
                });
        });
    });

    document.querySelectorAll('.active-filter').forEach((el) => {
        el.addEventListener('click', (e) => {
            e.preventDefault();

            const productList = document.querySelector('#main .product-list');

            if (productList) {
                productList.style.opacity = 0.25;
            }

            window.history.replaceState({}, '', e.target.getAttribute('href'));

            fetch(window.location.href)
                .then((response) => response.text())
                .then((data) => {
                    const parser = new DOMParser();
                    const newDocument = parser.parseFromString(data, 'text/html');
                    
                    document.querySelector('#main-col').replaceWith(newDocument.querySelector('#main-col'));
                    topbarCollectionFilters();
                    initAjaxinate();
                    initButtons();
                    fixCollectionSidebarStickyPos();
                    paginationafterfilter();
                });
        });
    });
};
topbarCollectionFilters();



